module.exports = __webpack_public_path__ + "img/click-for-price-ford-grid-button.52518099.gif";